require('./openYoungProfileDetailsView.scss');

// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { EmptyState } = require('commonsComponents/emptyState');

// @ components
const { CallMeBack } = require('components/callMeBack/callMeBack');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKMessage } = require('commonsComponents/OKMessage');

// @actions
const openYoungProfileDetailsActions = require('actions/openYoungProfileDetails');

// @constants
const {
    DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR,
    DOCUMENT_TYPE_NIE,
    GENDER_MALE,
} = require('constants/index');
const { getTranslatedCountry } = require('constants/countries');
const TAXING_REASON = require('constants/taxingReason');
const PROVINCES = require('constants/provinces');

class OpenYoungProfileDetailsView extends React.Component {
    constructor(props) {
        super(props);
        this.handleRetryButton = this.handleRetryButton.bind(this);
    }

    componentDidMount() {
        const {
            history,
            match: { params : {profileIndex} },
            getOpenYoungProfileDetails,
            immOpenYoungProfiles
        } = this.props;
        if (immOpenYoungProfiles.get('fetchSuccess')) {
            getOpenYoungProfileDetails(profileIndex);
        } else {
            history.push(`/myprofile/openyoung-profiles`);
        }
    }

    handleRetryButton() {
        const {
            match: { params : {profileIndex} },
            getOpenYoungProfileDetails,
        } = this.props;

        getOpenYoungProfileDetails(profileIndex);
    }

    buildEditButton(formType) {
        const { history, match: { params : { profileIndex } } } = this.props;
        return (
            <span className="open-young-profile-details-view__edit-section">
                <i
                    className="icon-editar"
                    onClick={() => {
                        history.push(`/myprofile/openyoung-profile-details/${profileIndex}/${formType}`);
                    }}
                />
            </span>
        )
    }

    buildListCountriesWithAdditionalTaxing() {
        const listCountriesAdditionalTaxing = this.props.immOpenYoungProfileDetails.get('countriesTributation');
        let content;
        if (!listCountriesAdditionalTaxing || (listCountriesAdditionalTaxing.size === 0 )) {
            content = <FormattedText className="open-young-profile-details-view__text-additional-tributation" value="profile-taxInformation_noAdditionalTributation"/>;
        } else {
            content = listCountriesAdditionalTaxing.map((immCountry, index) => {
                const country = getTranslatedCountry(immCountry.get('country'));
                const taxingReason = TAXING_REASON[immCountry.get('reason')];
                const tin = immCountry.get('tin');
                return (
                    <div className="open-young-profile-details-view__text-additional-tributation" key={index}>
                        {`${country}, ${taxingReason}. TIN: ${tin}`}
                    </div>
                );
            });
        }
        return content;
    }

    buildBeneficiaryInfo() {
        const { immOpenYoungProfileDetails } = this.props;
        let documentCodeType;
        let genderLabel;

        if (immOpenYoungProfileDetails.get('gender') === GENDER_MALE) {
            genderLabel = formatText('openYoungProfileDetails-openYoungProfileDetails_genderMale');
        } else {
            genderLabel = formatText('openYoungProfileDetails-openYoungProfileDetails_genderFemale');
        }

        if (immOpenYoungProfileDetails.get('documentCodeType') === DOCUMENT_TYPE_NIE) {
            documentCodeType = formatText('openYoungProfileDetails-openYoungProfileDetails_NIE');
        } else {
            documentCodeType = formatText('openYoungProfileDetails-openYoungProfileDetails_NIF');
        }

        return (
            <OKSectionBox title={formatText('openYoungProfileDetails-openYoungProfileDetails__openYoungPersonalInfo')}>
                <OKInformativeList
                    columns={3}
                    title={formatText('openYoungProfileDetails-openYoungProfileDetails_personalData')}
                >
                    <OKInformativeListItem
                        title={formatText('openYoungProfileDetails-openYoungProfileDetails_fullName')}
                        onlyChildren
                    >
                        {immOpenYoungProfileDetails.get('fullName')}
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={formatText('openYoungProfileDetails-openYoungProfileDetails_identification')}
                        onlyChildren
                    >
                        {documentCodeType} {immOpenYoungProfileDetails.get('documentCodeNumber')}
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={formatText('openYoungProfileDetails-openYoungProfileDetails_birthdate')}
                        onlyChildren
                    >
                        {immOpenYoungProfileDetails.get('birthDate').format(DATE_FORMAT_SLASHES_SHORT_DAY_MONTH_YEAR)}
                    </OKInformativeListItem>

                    <OKInformativeListItem
                        title={formatText('openYoungProfileDetails-openYoungProfileDetails_birthCountry')}
                        onlyChildren
                    >
                        {getTranslatedCountry(immOpenYoungProfileDetails.get('country'))}
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={formatText('openYoungProfileDetails-openYoungProfileDetails_birthProvince')}
                        onlyChildren
                    >
                        {PROVINCES[immOpenYoungProfileDetails.getIn(['provinceBirth', 'province'])]}
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={formatText('openYoungProfileDetails-openYoungProfileDetails_birthPopulation')}
                        onlyChildren
                    >
                        {immOpenYoungProfileDetails.get('populationBirth')}
                    </OKInformativeListItem>

                    <OKInformativeListItem
                        title={formatText('openYoungProfileDetails-openYoungProfileDetails_gender')}
                        onlyChildren
                    >
                        {genderLabel}
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={formatText('openYoungProfileDetails-openYoungProfileDetails_nationality')}
                        onlyChildren
                    >
                        {getTranslatedCountry(immOpenYoungProfileDetails.get('nationality'))}
                    </OKInformativeListItem>
                </OKInformativeList>
                <OKInformativeList
                    columns={1}
                    title={formatText('openYoungProfileDetails-openYoungProfileDetails_contactData')}
                    titleButton={this.buildEditButton('contact-data-edit')}
                >
                    <OKInformativeListItem
                        title={formatText('openYoungProfileDetails-openYoungProfileDetails_address')}
                        onlyChildren
                    >
                        {immOpenYoungProfileDetails.get('addressFormatted')}
                    </OKInformativeListItem>
                </OKInformativeList>
                <OKInformativeList
                    columns={1}
                    title={formatText('openYoungProfileDetails-openYoungProfileDetails_fiscalData')}
                    titleButton={this.buildEditButton('fiscal-data-edit')}
                >
                    <OKInformativeListItem
                        title={formatText('openYoungProfileDetails-openYoungProfileDetails_otherCountries')}
                        onlyChildren
                    >
                        {this.buildListCountriesWithAdditionalTaxing()}
                    </OKInformativeListItem>
                </OKInformativeList>
            </OKSectionBox>
        );
    }

    render () {
        const { immOpenYoungProfileDetails, immGlobalVariables } = this.props;
        const boxBody = (
            <OKMessage type="important">
                <FormattedText value="profile-boxBody" />
            </OKMessage>
        );
        const boxTitle = formatText('profile-boxTitle');
        const breadcrumbConfig = [{
            text: formatText('breadcrumb-personalInformation'),
            url: '/myprofile/edit'
        }, {
            text: formatText('breadcrumb-breadcrumb_openYoungInformation'),
            url: '/myprofile/openyoung-profiles'
        }, {
            text: formatText('breadcrumb-breadcrumb_personalDataOpenYoungInformation'),
            url: ''
        }];

        let content;
        if (immOpenYoungProfileDetails.get('isFetching')) {
            content = (
                <OKSectionBox>
                    <LoadingSection />
                </OKSectionBox>
            );
        } else if (immOpenYoungProfileDetails.get('error')){
            const retryButton = (
                <OKButton onClick={this.handleRetryButton}>
                    <FormattedText value="common-retry" />
                </OKButton>
            );

            content = (
                <OKSectionBox>
                    <EmptyState
                        button={retryButton}
                        iconType="nointernet-banking"
                        primaryText={formatText('openYoungProfileDetails-openYoungProfileDetails_errorText', [immGlobalVariables.getIn(['variables', 'parameters', 'telefono', 'cliente'])])}
                    />
                </OKSectionBox>
            );
        } else if (immOpenYoungProfileDetails.get('fetchSuccess')){
            content = this.buildBeneficiaryInfo();
        }
        return (
            <div className="open-young-profile-details-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="pg" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={breadcrumbConfig}
                                finalTitle={getFinalTitle('openYoungProfileDetails-openYoungProfileDetails_title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-12 col-md-8">
                                {content}
                            </div>

                            <div className="col-xs-12 col-md-4">
                                <div className="row">
                                    <div className="col-xs-12 grid-view--variable-cell-separation">
                                        <ContactInfoBox
                                            boxTitle={boxTitle}
                                            boxBody={boxBody}
                                            hasMessage={true}
                                        />
                                    </div>
                                    <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                                        <CallMeBack pageTitle={formatText('breadcrumb-personalInformation')} hasEntrance={false} />
                                    </div>
                                    <div className="col-xs-12 grid-view--fix-cell-separation">
                                        <CommercialAds path={'edit'} type="banner-a" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

OpenYoungProfileDetailsView.propTypes = {
    getOpenYoungProfileDetails: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immOpenYoungProfileDetails: PropTypes.object.isRequired,
    immOpenYoungProfiles: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
}

module.exports.constructor = OpenYoungProfileDetailsView;

module.exports.OpenYoungProfileDetailsView = connect(
    state => ({
        immOpenYoungProfileDetails: state.openYoungProfileDetails,
        immOpenYoungProfiles: state.openYoungProfiles,
        immGlobalVariables: state.globalVariables
    }), {
        getOpenYoungProfileDetails: openYoungProfileDetailsActions.getOpenYoungProfileDetails,
    }
)(withRouter(OpenYoungProfileDetailsView));
